baseIsNaN